"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.DASHBOARD_CACHE_SIZE = exports.INSIGHT_CACHE_SIZE = exports.LOADER_CACHE_SIZE = void 0;
/**
 * Loaders for how many different workspaces will be kept.
 */
exports.LOADER_CACHE_SIZE = 5;
/**
 * How many insights will be kept for each workspace.
 */
exports.INSIGHT_CACHE_SIZE = 20;
/**
 * Data for how many dashboards will be kept for each workspace.
 */
exports.DASHBOARD_CACHE_SIZE = 20;
//# sourceMappingURL=constants.js.map